/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Banner/theme';

export const BannerTheme = theme;
